import React, { Fragment } from 'react'
import { graphql } from 'react-apollo'
import { compose, lifecycle } from 'recompose'
import { withStyles } from '@material-ui/core/styles'

import withErrorState from '../hocs/withErrorState'
import withLoadingState from '../hocs/withLoadingState'
import withLocalization from '../hocs/withLocalization'
import withFlattenedTranslations from '../hocs/withFlattenedTranslations'
import withPageInfo from '../hocs/withPageInfo'
import withGeneralTranslations from '../hocs/withGeneralTranslations'
import withConnectionStatus from '../hocs/withConnectionStatus'
import withNotFoundWhenEmpty from '../hocs/withNotFoundWhenEmpty'

import buildAssetUrl from '../utils/buildAssetUrl'
import normalizeHotspots from '../utils/normalizeHotspots'

import Navigation from '../layouts/Navigation'
import {
  IntroSection,
  SummaryBar,
  ComponentSection,
  TopicSection
} from '../components'

import { sharedComponentStyles } from './Component'

import customerBenefitQuery from '../queries/customerBenefit'
import PodcastsReferences from "../components/PodcastsReferences";

class CustomerBenefit extends React.Component {
  componentDidMount() {
    this.updatePageInfo()
  }

  componentDidUpdate() {
    this.updatePageInfo()
  }

  updatePageInfo() {
    const { customerBenefit, pageInfo, setPageInfo } = this.props
    const { id, title } = customerBenefit
    if (pageInfo.title !== title || pageInfo.id !== id) {
      setPageInfo({
        id,
        title,
        type: 'customer-benefit'
      })
    }
  }

  render() {
    const { customerBenefit, generalTranslations, classes } = this.props
    const { title, headline, description, sections } = customerBenefit

    return (
      <Fragment>
        <Navigation enableOverviewShortcuts />
        <div className={classes.mainWrapperStyle}>
          <IntroSection
            kicker={generalTranslations('customer-benefit').toUpperCase()}
            title={title}
            headline={headline}
            description={description}
          >
            <PodcastsReferences podcasts={customerBenefit.podcasts}/>
          </IntroSection>
          <SummaryBar sections={sections} />

          <div className={classes.sectionsWrapperStyle}>
            {sections.map((section, index) => {
              const {
                headline,
                description,
                slug,

                assetsWithDescription,
                table,

                hotspotImage,
                localizedHotspotImage,
                hotspots
              } = section

              if (hotspotImage) {
                // must be topic style section
                const image = localizedHotspotImage || hotspotImage

                const normalizedHotspots = normalizeHotspots(image, hotspots)

                const { url: imageUrl } = buildAssetUrl(image)

                return (
                  <TopicSection
                    headline={headline}
                    description={description}
                    image={imageUrl}
                    hotspots={normalizedHotspots}
                    isLastSection={index === sections.length - 1}
                    key={slug}
                    anchorId={slug}
                  />
                )
              }

              return (
                <ComponentSection
                  headline={headline}
                  description={description}
                  medias={assetsWithDescription}
                  isLastSection={index === sections.length - 1}
                  key={slug}
                  anchorId={slug}
                  table={table}
                />
              )
            })}
          </div>
        </div>
      </Fragment>
    )
  }
}

export default compose(
  withConnectionStatus,
  withGeneralTranslations,
  withLocalization,
  graphql(customerBenefitQuery, {
    options: ({ language, match, fetchPolicy, stage }) => ({
      variables: {
        slug: match.params.slug,
        lang: language.toLowerCase(),
        stage
      },
      fetchPolicy
    })
  }),
  withErrorState,
  withLoadingState('customerBenefit'),
  withNotFoundWhenEmpty('customerBenefit'),
  withFlattenedTranslations('customerBenefit'),
  withPageInfo,
  withStyles(sharedComponentStyles)
)(CustomerBenefit)

const CustomerBenefitPrintView = ({
  generalTranslations,
  customerBenefit,
  classes
}) => {
  const { title, headline, description, sections } = customerBenefit

  if (!title || !sections) {
    return <div>Component not fully loaded, cannot be printed!</div>
  }

  return (
    <Fragment>
      <div className={classes.mainWrapperStyle}>
        <IntroSection
          kicker={generalTranslations('customer-benefit').toUpperCase()}
          title={title}
          headline={headline}
          description={description}
        />

        <div className={classes.sectionsWrapperPrintStyle}>
          {sections.map((section, index) => {
            const {
              headline,
              description,
              slug,

              assetsWithDescription,
              table,

              hotspotImage,
              localizedHotspotImage,
              hotspots
            } = section

            if (hotspotImage) {
              // must be topic style section
              const image = localizedHotspotImage || hotspotImage

              const normalizedHotspots = normalizeHotspots(image, hotspots)

              const { url: imageUrl } = buildAssetUrl(image)

              return (
                <TopicSection
                  headline={headline}
                  description={description}
                  image={imageUrl}
                  hotspots={normalizedHotspots}
                  isLastSection={index === sections.length - 1}
                  key={slug}
                  anchorId={slug}
                />
              )
            }

            return (
              <ComponentSection
                headline={headline}
                description={description}
                medias={assetsWithDescription}
                isLastSection={index === sections.length - 1}
                key={slug}
                anchorId={slug}
                table={table}
              />
            )
          })}
        </div>
      </div>
    </Fragment>
  )
}

export const CustomerBenefitPrint = compose(
  withConnectionStatus,
  withGeneralTranslations,
  withLocalization,
  graphql(customerBenefitQuery, {
    options: ({ language, slug, fetchPolicy, stage }) => ({
      variables: {
        slug,
        lang: language.toLowerCase(),
        stage
      },
      fetchPolicy
    })
  }),
  withErrorState,
  withLoadingState('customerBenefit'),
  withNotFoundWhenEmpty('customerBenefit'),
  withFlattenedTranslations('customerBenefit'),
  withStyles(sharedComponentStyles),
  lifecycle({
    componentDidMount() {
      this.props.onMounted(this.props.slug)
    }
  })
)(CustomerBenefitPrintView)



// WEBPACK FOOTER //
// ./src/screens/CustomerBenefit.js